import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var aadhaarVerificationConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: false,
  stepDetailsProps: {
    title: 'STEP 2',
    heading: 'Aadhaar verification',
    avatarIcon: 'AadhaarIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  inputsDataProps: {
    aadhaarNumber: {
      label: '12-digit Aadhaar number/16-digit VID',
      showAppend: false,
      inputRegex: '^\\d+$',
      keyboardType: 'phone-pad',
      useStateHintColor: true,
      placeholder: 'Enter Aadhaar or VID number',
      validationRegex: '^\\d{12}$|^\\d{16}$',
      maxLength: 16,
      showLabelIcon: true,
      labelTooltipProps: {
        position: 'bottom-center',
        text: 'VID is a temporary, 16-digit number linked to your Aadhaar. To get a new VID, send an SMS to 1947 in the format: RVID [Last 4 or 8 digits of Aadhaar]. from your registered mobile number.'
      }
    }
  },
  submitButtonProps: {
    leftCta: {
      version: 'variable-width',
      title: 'Verify Aadhaar Via OTP',
      size: 'md'
    },
    style: {
      zIndex: -1
    }
  },
  checkboxProps: {
    label: 'I agree to all terms and conditions.',
    value: 'agree_T&C',
    actionCta: 'View T&C'
  }
};
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};